export const useABTest = <T, K>(a: T, b: K): T | K => {
  const random = Math.random() >= 0.5
  return random ? a : b
}
